import {
    Col,
    message,
    PageHeader,
    Row,
    Spin,
    Select,
    Space,
    Tabs,
  } from "antd";
  import axios from "axios";
  import React, { Component } from "react";
  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  import { connect } from "react-redux";
  import {
    SelectItem,
    Form,
    FormItem,
    cuentaMask,
    TableItem,
    dineroDisabledMask,
    RangePickerItem,
    ButtonItem,
    ErrorItem
  } from "../../../../Components/Items";
  import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
  import AccionesPolizaReporte from "../../../../Components/AccionesPolizaReporte";
  import ModalPdfPoliza from "../../../../Components/ModalPdfPoliza";
  import ModalEditarPoliza from "../../../../Components/ModalEditarPoliza";
  import * as XLSX from "xlsx";
  import * as XLSXStyle from "xlsx-js-style";
  import moment from "moment";
  import "moment/locale/es";
import reporteLibroDiarioPdf from "../../../../Pdf/reporteDeLibroDiarioPdf";
  
  moment.locale("es");
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  
  const { Option } = Select;
  const { TabPane } = Tabs;
  
  class ReporteLibroDiario extends Component {
    state = {
      loading: false,
      pdf: null,
      objetoProyectos: null,
      todasProyectos: null,
      objetoUniadesDeNegocio: null,
      todasUniadesDeNegocio: null,
      dataReporte: null,
      todasPolizasCA: [],
      ultimosFiltros: null,
      modalPdfPoliza: false,
      polizaIdPdf: null,
      modalEditarPoliza: false,
      polizaIdEditar: null,
    };

    atras() {
      this.props.history.goBack();
    }

    abrirVerPoliza = (polizaId) => {
      this.setState({ modalPdfPoliza: true, polizaIdPdf: polizaId });
    };
    cerrarVerPoliza = () => {
      this.setState({ modalPdfPoliza: false, polizaIdPdf: null });
    };
    abrirEditarPoliza = (polizaId) => {
      this.setState({ modalEditarPoliza: true, polizaIdEditar: polizaId });
    };
    cerrarEditarPoliza = () => {
      this.setState({ modalEditarPoliza: false, polizaIdEditar: null });
    };
    // Se vuelve a consultar con los mismos filtros para que el reporte refleje el cambio.
    polizaEditada = () => {
      if (this.state.ultimosFiltros) {
        this.consultarReporteLibroDiario(this.state.ultimosFiltros);
      }
    };
  
    async componentDidMount() {
      this.setState({ loading: true });
      await axios
        .post(
          "proyectos/selectProyectos",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasProyectos: res.data });
            this.setState({
              objetoProyectos: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
      await axios
        .post(
          "unidadesdenegocio/selectUnidadesDeNegocio",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasUniadesDeNegocio: res.data });
            this.setState({
              objetoUniadesDeNegocio: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {cuentaMask(
                      value.nivel1 +
                        value.nivel2 +
                        value.nivel3 +
                        value.nivel4 +
                        value.nivel5
                    ) +
                      " - " +
                      value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
      this.consultarReporteLibroDiario({
        periodo: [moment().subtract(1, "month"), moment()],
      });
    }
  
    consultarReporteLibroDiario(values) {
      this.setState({ loading: true, ultimosFiltros: values });
      axios
        .post(
          "reportesFinancieros/reporteLibroDiario",
          { ...values, empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {

            let todasPolizasCA = []

            for (const valuePoliza of res.data.polizasFinales) {
              const datosPoliza = {
                polizaId: valuePoliza._id,
                polizaManual: valuePoliza.manual,
                polizaEstado: valuePoliza.estado,
              }

              todasPolizasCA.push({
                colSpan: 5,
                cuenta: valuePoliza.concepto+' : '+valuePoliza.numeroTipoPoliza+' - '+valuePoliza.numeroTipoTipoPoliza,
                ...datosPoliza,
              })

              for (const valueCA of valuePoliza.cargosAbonos) {
                todasPolizasCA.push({
                  ...valueCA,
                  ...datosPoliza,
                  cargo: valueCA.cargo ? valueCA.monto : '-',
                  abono: !valueCA.cargo ? valueCA.monto : '-',
                  descripcion: valueCA.cuentaContable.descripcion,
                  cuenta: cuentaMask(
                    valueCA.cuentaContable.nivel1 +
                      valueCA.cuentaContable.nivel2 +
                      valueCA.cuentaContable.nivel3 +
                      valueCA.cuentaContable.nivel4 +
                      valueCA.cuentaContable.nivel5
                  )
                })
              }
            }

            this.setState({
              loading: false,
              dataReporte: res.data,
              todasPolizasCA: todasPolizasCA
            });
          } else if (res.data.success === 1) {
            message.error("Ha sucedido un error y no se cargo bien el reporte");
          } else {
            message.error("Ha sucedido un error y no se cargo bien el reporte");
          }
          this.setState({ loading: false });
        });
    }
  
    descargarExcel() {
      let datosDescargar = [];
  
      for (const valuePoliza of this.state.dataReporte.polizasFinales) {
        let ied
        if(valuePoliza.tipodepoliza.tipoDePolizaId === 1){
            ied = 'Ingreso'
        }
        if(valuePoliza.tipodepoliza.tipoDePolizaId === 2){
            ied = 'Egreso'
        }
        if(valuePoliza.tipodepoliza.tipoDePolizaId === 3){
            ied = 'Traslado'
        }
        if(valuePoliza.tipodepoliza.tipoDePolizaId === 4){
            ied = 'Nomina'
        }
        if(valuePoliza.tipodepoliza.tipoDePolizaId === 5){
            ied = 'Pago'
        }
        if(valuePoliza.tipodepoliza.tipoDePolizaId === 6){
            ied = 'Diario'
        }
        for (const valueCA of valuePoliza.cargosAbonos) {
          datosDescargar.push({
            Fecha: moment(valuePoliza.fechaRegistro).locale("es").format("L"),
            "Tipo Poliza ": ied,
            "No. Poliza ": valuePoliza.numeroTipoTipoPoliza,
            "Tipo Poliza": valuePoliza.tipodepoliza.descripcion,
            "No. Poliza": valuePoliza.numeroTipoPoliza,
            // El proyecto del renglon, no el del encabezado: una poliza puede repartir sus
            // movimientos entre varios proyectos y el encabezado guarda solo el principal.
            Proyecto: valueCA.proyectoNombre || valuePoliza.proyecto.nombre+' - '+valuePoliza.proyecto.descripcion,
            "Concepto Poliza": valuePoliza.concepto,
            Cuenta: cuentaMask(
              valueCA.cuentaContable.nivel1 +
                valueCA.cuentaContable.nivel2 +
                valueCA.cuentaContable.nivel3 +
                valueCA.cuentaContable.nivel4 +
                valueCA.cuentaContable.nivel5
            ),
            Descripcion: valueCA.cuentaContable.descripcion,
            "Concepto": valueCA.concepto,
            Cargo: valueCA.cargo ? valueCA.monto : 0,
            Abono: !valueCA.cargo ? valueCA.monto : 0,
          });
        }
      }
  
      const worksheet = XLSX.utils.json_to_sheet(datosDescargar);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Libro Diario"
      );
      //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
      //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(
        workbook,
        `Libro_Diario_${moment().locale("es").format("L")}.xlsx`
      );
    }
  
    descargarExcelPorPoliza() {
      const polizasFinales = this.state.dataReporte.polizasFinales;
      if (!polizasFinales || polizasFinales.length === 0) {
        return message.info("No hay pólizas para exportar.");
      }

      const FORMATO_CONTABILIDAD =
        '_-"$"* #,##0.00_-;-"$"* #,##0.00_-;_-"$"* "-"??_-;_-@_-';

      const border = {
        top: { style: "thin", color: { auto: 1 } },
        bottom: { style: "thin", color: { auto: 1 } },
        left: { style: "thin", color: { auto: 1 } },
        right: { style: "thin", color: { auto: 1 } },
      };

      const tituloStyle = {
        font: { bold: true, color: { rgb: "FFFFFF" }, sz: 13 },
        fill: { fgColor: { rgb: "007A8A" } },
        alignment: { horizontal: "left", vertical: "center" },
        border,
      };

      const etiquetaStyle = {
        font: { bold: true, sz: 10 },
        alignment: { horizontal: "left" },
      };

      const valorStyle = {
        font: { sz: 10 },
        alignment: { horizontal: "left" },
      };

      const headerStyle = {
        font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11 },
        fill: { fgColor: { rgb: "00BFD6" } },
        alignment: { horizontal: "center", vertical: "center" },
        border,
      };

      const cellStyle = (isAlt) => ({
        font: { sz: 10 },
        fill: { fgColor: { rgb: isAlt ? "F5FBFC" : "FFFFFF" } },
        alignment: { horizontal: "left" },
        border,
      });

      const numCellStyle = (isAlt) => ({
        font: { sz: 10 },
        fill: { fgColor: { rgb: isAlt ? "F5FBFC" : "FFFFFF" } },
        alignment: { horizontal: "right" },
        numFmt: FORMATO_CONTABILIDAD,
        border,
      });

      const totalLabelStyle = {
        font: { bold: true, sz: 10 },
        fill: { fgColor: { rgb: "E6F7FF" } },
        alignment: { horizontal: "left" },
        border,
      };

      const totalNumStyle = {
        font: { bold: true, sz: 10 },
        fill: { fgColor: { rgb: "E6F7FF" } },
        alignment: { horizontal: "right" },
        numFmt: FORMATO_CONTABILIDAD,
        border,
      };

      const celdaMoneda = (valor, estilo) =>
        valor ? { v: valor, t: "n", s: estilo } : { v: "", s: estilo };

      const workbook = XLSXStyle.utils.book_new();
      const nombresUsados = new Set();

      const nombreDeHoja = (base) => {
        let nombre = base.toString().replace(/[\\/*?:[\]]/g, "").trim() || "Poliza";
        nombre = nombre.slice(0, 31);
        let candidato = nombre;
        let contador = 2;
        while (nombresUsados.has(candidato)) {
          const sufijo = ` (${contador})`;
          candidato = nombre.slice(0, 31 - sufijo.length) + sufijo;
          contador++;
        }
        nombresUsados.add(candidato);
        return candidato;
      };

      for (const valuePoliza of polizasFinales) {
        let ied;
        let iedInicial;
        if (valuePoliza.tipodepoliza.tipoDePolizaId === 1) {
          ied = "Ingreso";
          iedInicial = "I";
        }
        if (valuePoliza.tipodepoliza.tipoDePolizaId === 2) {
          ied = "Egreso";
          iedInicial = "E";
        }
        if (valuePoliza.tipodepoliza.tipoDePolizaId === 3) {
          ied = "Traslado";
          iedInicial = "T";
        }
        if (valuePoliza.tipodepoliza.tipoDePolizaId === 4) {
          ied = "Nomina";
          iedInicial = "N";
        }
        if (valuePoliza.tipodepoliza.tipoDePolizaId === 5) {
          ied = "Pago";
          iedInicial = "P";
        }
        if (valuePoliza.tipodepoliza.tipoDePolizaId === 6) {
          ied = "Diario";
          iedInicial = "D";
        }

        const rows = [];
        const merges = [];

        merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: 4 } });
        rows.push([
          {
            v: `${valuePoliza.concepto} : ${valuePoliza.numeroTipoPoliza} - ${valuePoliza.numeroTipoTipoPoliza}`,
            t: "s",
            s: tituloStyle,
          },
          ...Array(4).fill({ v: "", t: "s", s: tituloStyle }),
        ]);

        const filaEtiquetaValor = (etiqueta, valor) => [
          { v: etiqueta, t: "s", s: etiquetaStyle },
          { v: valor, t: "s", s: valorStyle },
        ];

        rows.push(
          filaEtiquetaValor(
            "Fecha:",
            moment(valuePoliza.fechaRegistro).locale("es").format("L")
          )
        );
        rows.push(filaEtiquetaValor("Concepto:", valuePoliza.concepto));
        rows.push(
          filaEtiquetaValor("Tipo Póliza:", `(${iedInicial}) ${ied}`)
        );
        rows.push(
          filaEtiquetaValor(
            "No. Póliza:",
            `${ied}: ${valuePoliza.numeroTipoTipoPoliza}`
          )
        );
        rows.push(
          filaEtiquetaValor(
            "No. Póliza (tipo):",
            `${valuePoliza.tipodepoliza.descripcion}: ${valuePoliza.numeroTipoPoliza}`
          )
        );
        rows.push(
          filaEtiquetaValor(
            "Proyecto:",
            // proyectoRenglones sale de los movimientos incluidos en el reporte; el del
            // encabezado es solo el principal. Dice "Varios proyectos" si la poliza los reparte.
            valuePoliza.proyectoRenglones ||
              `${valuePoliza.proyecto.nombre} - ${valuePoliza.proyecto.descripcion}`
          )
        );

        rows.push([]);

        rows.push(
          ["Cuenta", "Descripción", "Concepto", "Cargo", "Abono"].map((h) => ({
            v: h,
            t: "s",
            s: headerStyle,
          }))
        );

        let cargosTotal = 0;
        let abonosTotal = 0;
        valuePoliza.cargosAbonos.forEach((valueCA, idx) => {
          const alt = idx % 2 === 1;
          const cargo = valueCA.cargo ? valueCA.monto : 0;
          const abono = !valueCA.cargo ? valueCA.monto : 0;
          cargosTotal += cargo;
          abonosTotal += abono;
          rows.push([
            {
              v: cuentaMask(
                valueCA.cuentaContable.nivel1 +
                  valueCA.cuentaContable.nivel2 +
                  valueCA.cuentaContable.nivel3 +
                  valueCA.cuentaContable.nivel4 +
                  valueCA.cuentaContable.nivel5
              ),
              t: "s",
              s: cellStyle(alt),
            },
            { v: valueCA.cuentaContable.descripcion, t: "s", s: cellStyle(alt) },
            { v: valueCA.concepto, t: "s", s: cellStyle(alt) },
            celdaMoneda(cargo, numCellStyle(alt)),
            celdaMoneda(abono, numCellStyle(alt)),
          ]);
        });

        const totRowIdx = rows.length;
        merges.push({ s: { r: totRowIdx, c: 0 }, e: { r: totRowIdx, c: 2 } });
        rows.push([
          { v: "Total:", t: "s", s: totalLabelStyle },
          { v: "", t: "s", s: totalLabelStyle },
          { v: "", t: "s", s: totalLabelStyle },
          celdaMoneda(cargosTotal, totalNumStyle),
          celdaMoneda(abonosTotal, totalNumStyle),
        ]);

        const worksheet = XLSXStyle.utils.aoa_to_sheet(rows);
        worksheet["!merges"] = merges;
        worksheet["!cols"] = [
          { wch: 16 },
          { wch: 32 },
          { wch: 32 },
          { wch: 16 },
          { wch: 16 },
        ];

        const nombreHoja = nombreDeHoja(`${ied} ${valuePoliza.numeroTipoTipoPoliza}`);
        XLSXStyle.utils.book_append_sheet(workbook, worksheet, nombreHoja);
      }

      XLSXStyle.writeFile(
        workbook,
        `Libro_Diario_Por_Poliza_${moment().locale("es").format("L")}.xlsx`
      );
    }

    descargarPdf() {
      pdfMake
        .createPdf(reporteLibroDiarioPdf(this.state.dataReporte))
        .download(
          `Libro_Diario_${moment().locale("es").format("L")}`
        );
    }
  
    onFinishFailed(e) {
      ErrorItem(e);
    }
  
    render() {
      const columns = [
        {
          title: "Cuenta",
          dataIndex: "cuenta",
          key: "cuenta",
          sorter: (a, b) => {
            if (a.cuenta < b.cuenta) {
              return -1;
            }
            if (a.cuenta > b.cuenta) {
              return 1;
            }
            return 0;
          },
          buscar: "cuenta",
          onCell: (record) => {
            return {
              colSpan: record.colSpan === 5 ? 5 : 1,
            }
          },
          ellipsis: false,
        },
        {
          title: "Descripcion",
          dataIndex: "descripcion",
          key: "descripcion",
          sorter: (a, b) => {
            if (a.descripcion < b.descripcion) {
              return -1;
            }
            if (a.descripcion > b.descripcion) {
              return 1;
            }
            return 0;
          },
          buscar: "descripcion",
          onCell: (record) => {
            return {
              colSpan: record.colSpan === 5 ? 0 : 1,
            }
          },
          ellipsis: true,
        },
        {
          title: "Concepto",
          dataIndex: "concepto",
          key: "concepto",
          sorter: (a, b) => {
            if (a.concepto < b.concepto) {
              return -1;
            }
            if (a.concepto > b.concepto) {
              return 1;
            }
            return 0;
          },
          buscar: "concepto",
          onCell: (record) => {
            return {
              colSpan: record.colSpan === 5 ? 0 : 1,
            }
          },
          ellipsis: true,
        },
        {
          title: "Cargo",
          dataIndex: "cargo",
          key: "cargo",
          sorter: (a, b) => {
            if (a.cargo < b.cargo) {
              return -1;
            }
            if (a.cargo > b.cargo) {
              return 1;
            }
            return 0;
          },
          buscar: "cargo",
          render: (value) => isNaN(value) ? value : dineroDisabledMask(value),
          onCell: (record) => {
            return {
              colSpan: record.colSpan === 5 ? 0 : 1,
            }
          },
          align: "right",
          ellipsis: true,
        },
        {
          title: "Abono",
          dataIndex: "abono",
          key: "abono",
          sorter: (a, b) => {
            if (a.abono < b.abono) {
              return -1;
            }
            if (a.abono > b.abono) {
              return 1;
            }
            return 0;
          },
          buscar: "abono",
          render: (value) => isNaN(value) ? value : dineroDisabledMask(value),
          onCell: (record) => {
            return {
              colSpan: record.colSpan === 5 ? 0 : 1,
            }
          },
          align: "right",
          ellipsis: true,
        },
        {
          // En el renglon de encabezado de poliza la primera columna abarca 5 celdas,
          // asi que esta queda libre y ahi caen los botones de esa poliza.
          title: "Acción",
          dataIndex: "accion",
          key: "accion",
          align: "center",
          width: "8%",
          render: (value, record) => (
            <AccionesPolizaReporte
              polizaId={record.polizaId}
              polizaManual={record.polizaManual}
              polizaEstado={record.polizaEstado}
              permisoEditarPolizas={this.props.permisoEditarPolizas}
              editarTodasLasPolizas={this.props.editarTodasLasPolizas}
              onVer={this.abrirVerPoliza}
              onEditar={this.abrirEditarPoliza}
            />
          ),
        },
      ];
      return (
        <>
          <Form
            ref={this.formRef}
            name="rerpoteLibroDiario"
            onFinish={this.consultarReporteLibroDiario.bind(this)}
            onFinishFailed={this.onFinishFailed}
            inita
          >
            <PageHeader
              onBack={this.atras.bind(this)}
              title="Reporte Libro Diario"
              style={{
                border: "1px solid rgb(235, 237, 240)",
                backgroundColor: "white",
                marginBottom: 10,
              }}
              extra={
                <div style={{ display: "flex", justifyContent: "right" }}>
                  <Space>
                    {this.state.dataReporte && (
                      <ButtonItem
                        blanco
                        onClick={() => this.descargarExcel()}
                        icon={<FileExcelOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar Excel
                      </ButtonItem>
                    )}
                    {this.state.dataReporte && (
                      <ButtonItem
                        blanco
                        onClick={() => this.descargarExcelPorPoliza()}
                        icon={<FileExcelOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar Excel por Póliza
                      </ButtonItem>
                    )}
                    {this.state.dataReporte && (
                      <ButtonItem
                        blanco
                        onClick={() => this.descargarPdf()}
                        icon={<FilePdfOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar PDF
                      </ButtonItem>
                    )}
                    <ButtonItem
                      type="primary"
                      htmlType="submit"
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Consultar
                    </ButtonItem>
                  </Space>
                </div>
              }
            />
            <Spin spinning={this.state.loading}>
              <div
                style={{
                  backgroundColor: "white",
                  padding: 20,
                  paddingTop: 5,
                  borderRadius: 5,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
              >
                <Tabs
                  style={{ margin: 0 }}
                  tabBarExtraContent={{
                    left: (
                      <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                        Filtros:
                      </h1>
                    ),
                  }}
                >
                    <TabPane tabKey="3" key="3" forceRender tab="Periodo">
                    <FormItem initialValue={[moment().subtract(1, "month"), moment()]} name="periodo" required noStyle>
                      <RangePickerItem />
                    </FormItem>
                    </TabPane>
                  <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                    <Row>
                      <Col span={8}>
                        <FormItem
                          name="filtrarProyecto"
                          required
                          noStyle
                          initialValue={0}
                        >
                          <SelectItem width="90%" placeholder="Filtrar Proyecto">
                            <Option default value={0}>
                              Niguno
                            </Option>
                            <Option value={1}>Proyectos</Option>
                            <Option value={2}>Unidades de negocio</Option>
                          </SelectItem>
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        <FormItem shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const filtrarProyecto =
                              getFieldValue("filtrarProyecto");
                            if (filtrarProyecto === 1) {
                              return (
                                <FormItem required name="proyectos" noStyle>
                                  <SelectItem
                                    width="90%"
                                    placeholder="Proyectos"
                                    mode="multiple"
                                  >
                                    {this.state.objetoProyectos}
                                  </SelectItem>
                                </FormItem>
                              );
                            }
                            if (filtrarProyecto === 2) {
                              return (
                                <FormItem
                                  required
                                  name="unidadDeNegocioId"
                                  noStyle
                                >
                                  <SelectItem
                                    width="90%"
                                    placeholder="Unidades de Negocio"
                                  >
                                    {this.state.objetoUniadesDeNegocio}
                                  </SelectItem>
                                </FormItem>
                              );
                            }
                          }}
                        </FormItem>
                      </Col>
                    </Row>
                  </TabPane>
                </Tabs>
              </div>
              <h1 style={{ textAlign: "center" }}>Polizas</h1>
              <TableItem
                columns={columns}
                dataSource={this.state.todasPolizasCA}
                size="small"
                pagination={false}
                rowKey={(value, index) => (value._id ? value._id.toString() : "p") + "_" + index}
                onRow={(record) => ({
                  onDoubleClick: () => {
                    if (record.polizaId) this.abrirVerPoliza(record.polizaId);
                  },
                })}
              />
            </Spin>
          </Form>
          <ModalPdfPoliza
            visible={this.state.modalPdfPoliza}
            polizaId={this.state.polizaIdPdf}
            onCancel={this.cerrarVerPoliza}
          />
          <ModalEditarPoliza
            visible={this.state.modalEditarPoliza}
            polizaId={this.state.polizaIdEditar}
            onCancel={this.cerrarEditarPoliza}
            onGuardado={this.polizaEditada}
          />
        </>
      );
    }
  }
  
  const mapStateToProps = (state) => {
    return {
      headersToken: state.user.headersToken,
      empresaId: state.empresa.id,
      permisoEditarPolizas: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cea8ff30e81b54183cfbf")?.activado,
      editarTodasLasPolizas: state.empresa.editarTodasLasPolizas,
    };
  };

  export default connect(mapStateToProps)(ReporteLibroDiario);
  